var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 21.125C16.75 17.8435 16.7851 16.75 21.125 16.75C25.4649 16.75 25.5 17.8435 25.5 21.125C25.5 24.4065 25.5138 25.5 21.125 25.5C16.7362 25.5 16.75 24.4065 16.75 21.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 21.125C30.5 17.8435 30.5351 16.75 34.875 16.75C39.2149 16.75 39.25 17.8435 39.25 21.125C39.25 24.4065 39.2638 25.5 34.875 25.5C30.4862 25.5 30.5 24.4065 30.5 21.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 34.875C16.75 31.5935 16.7851 30.5 21.125 30.5C25.4649 30.5 25.5 31.5935 25.5 34.875C25.5 38.1565 25.5138 39.25 21.125 39.25C16.7362 39.25 16.75 38.1565 16.75 34.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 34.875C30.5 31.5935 30.5351 30.5 34.875 30.5C39.2149 30.5 39.25 31.5935 39.25 34.875C39.25 38.1565 39.2638 39.25 34.875 39.25C30.4862 39.25 30.5 38.1565 30.5 34.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.339203d37fcc987e5d6172f56e4a2c03.svg";
export { ForwardRef as ReactComponent };